<template>
  <div>
    <keep-alive>
      <component :is="enter" :changes="changes"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
      rowObj:{}
    };
  },
  components: {
    // 监控页面
    monitorIndex: () => import("./components/monitorIndex.vue"),
    // 考试查询
    examInquiry: () => import("./components/examInquiry.vue"),
    // 提前交卷
    studentExamWinding: () => import("./components/studentExamWinding.vue"),
    // 添加考生
    insertExamStudent: () => import("./components/insertExamStudent.vue"),
  },
  computed: {
    enter() {
      switch (this.isActive) {
        case 0:
          return "monitorIndex";
        case 1:
          return "examInquiry";
        case 2:
          return "studentExamWinding";
        case 3:
          return "insertExamStudent";
      }
      return "page";
    },
  },
  methods: {
    changes(index) {
       if (index == "0" && this.isActive == "1") {
        this.$children[0].Buriedpoint({
          code: "OnlineTest:Monitoring:testQuery",
          parent_code: "OnlineTest:Monitoring",
        });
      }
      this.isActive = index;
    },
  },
};
</script>
